import { UUID } from "crypto";

export const partnerPreferencesKeys = {
  all: ["partnerPreferences"] as const,
  lists: () => [...partnerPreferencesKeys.all, "list"] as const,
  list: (partnerId: UUID) =>
    [...partnerPreferencesKeys.lists(), partnerId] as const,
  general: (partnerId: UUID) =>
    [...partnerPreferencesKeys.all, "general", partnerId] as const,
  products: (partnerId: UUID) =>
    [...partnerPreferencesKeys.all, "products", partnerId] as const,
  detail: (preferenceId: UUID) =>
    [...partnerPreferencesKeys.all, "detail", preferenceId] as const,
} as const;
